export default {
  title: "Saldo",
  descriptionDefault: "Consulte sus ingresos y movimientos",
  descriptionFull: "Consulte todos los movimientos de sus actividades",
  hostIdMissing: "No se encontró el ID de usuario del anfitrión",
  salesAgentIdMissing: "No se encontró el ID de usuario del agente de ventas",
  sellerIdMissing: "No se encontró el ID de usuario del vendedor",
  loadingBalance: "Cargando datos del saldo...",
  errorLoad: "Error al cargar los datos de la cartera",
  statCurrentBalance: "Saldo actual",
  statAmountOwed: "Importe adeudado",
  statTotalIncome: "Ingresos del periodo",
  statTotalExpenses: "Gastos del periodo",
  statTransactions: "{{count}} movimientos en el periodo",
  periodLabel: "Periodo",
  filtersTitle: "Filtros de búsqueda",
  filtersActive_one: "{{count}} filtro activo",
  filtersActive_other: "{{count}} filtros activos",
  filtersHint: "Use filtros para acotar los resultados",
  dateRange: "Rango de fechas",
  from: "Desde",
  to: "Hasta",
  searchCriteria: "Criterios de búsqueda",
  searchDescriptionLabel: "Buscar en la descripción",
  searchDescriptionPlaceholder: "Buscar movimientos...",
  activityLabel: "Actividad",
  allActivities: "Todas las actividades",
  amountRange: "Rango de importe",
  minAmount: "Importe mínimo (€)",
  maxAmount: "Importe máximo (€)",
  placeholderMin: "0,00",
  placeholderMax: "Sin límite",
  clearFilters: "Borrar todos los filtros",
  applyFilters: "Aplicar filtros nuevos",
  searchTransactions: "Buscar movimientos",
  unsavedFilters:
    "Tiene cambios de filtros sin guardar. Pulse «Aplicar filtros nuevos» para buscar.",
  transactionsTitle: "Movimientos",
  results_one: "{{count}} resultado",
  results_other: "{{count}} resultados",
  loadingTransactions: "Cargando movimientos...",
  emptyTitle: "No hay movimientos",
  emptyDescFiltered: "Pruebe a ajustar los filtros",
  emptyDescDefault: "Sus movimientos aparecerán aquí",
} as const;
